<template>
  <el-dialog :close-on-click-modal="false" :title="$t('sim-ka-xiang-qing')" :visible="detailFormVisible" :modal-append-to-body='false' @close="closeDetailForm">
    <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
          <el-col :span="12">
            <el-form-item :label="$t('ying-ye-shang-xin-xi')" :label-width="formLabelWidth" prop="operatorType">
              <label  v-text="detailForm.businessName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('tao-can-lei-xing')" :label-width="formLabelWidth" prop="packageType">
              <label v-text="detailForm.packageType"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('liu-liang-mb-0')" :label-width="formLabelWidth" prop="flow">
              <label v-text="detailForm.flow"></label>
            </el-form-item>
          </el-col>
          <!--              <el-col :span="12">-->
          <!--                <el-form-item label="通话时长：" :label-width="formLabelWidth" prop="callDuration">-->
          <!--                  <label v-text="detailForm.callDuration"></label>-->
          <!--                </el-form-item>-->
          <!--              </el-col>-->
          <!--              <el-col :span="12">-->
          <!--                <el-form-item label="短信条数：" :label-width="formLabelWidth" prop="smsCount">-->
          <!--                  <label v-text="detailForm.smsCount"></label>-->
          <!--                </el-form-item>-->
          <!--              </el-col>-->
          <el-col :span="12">
            <el-form-item :label="$t('ka-hao-0')" :label-width="formLabelWidth" prop="cardNo">
              <label v-text="detailForm.cardNo"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('yun-ying-shang')" :label-width="formLabelWidth" prop="operatorName">
              <label v-text="detailForm.operatorName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('zhan-ming-cheng')" :label-width="formLabelWidth" prop="pileName">
              <label v-text="detailForm.stationName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('zhuang-ming-cheng')" :label-width="formLabelWidth" prop="stationName">
              <label v-text="detailForm.pileName"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('you-xiao-ri-qi')" :label-width="formLabelWidth" prop="validityPeriod">
              <label v-text="detailForm.validityPeriod"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lin-jin-you-xiao-qi-de-tong-zhi-shou-ji-hao-ma')" :label-width="formLabelWidth" prop="phone">
              <label v-text="detailForm.phone"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lin-jin-you-xiao-qi-de-tong-zhi-you-xiang')" :label-width="formLabelWidth" prop="email">
              <label v-text="detailForm.email"></label>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('fu-fei-lei-xing')" :label-width="formLabelWidth" prop="payType">
              <label v-if="detailForm.payType" v-text="detailForm.payType.message"></label>
            </el-form-item>
          </el-col>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="closeDetailForm">{{ $t('que-ding') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation'],
        formLabelWidth: '150px',
      }
    },
    props:{
      detailFormVisible:false,
      detailForm: {},
    },
    methods:{
      closeDetailForm(){
        this.$emit("closeDetailForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager/detail.vue